import React from "react";
import styled from "styled-components";
import PageHeader from "../../components/organisms/PageHeader";
import museum1 from "../../assets/images/museum1.jpg"
import museum2 from "../../assets/images/museum2.jpg"
import museum3 from "../../assets/images/museum3.jpg"
import museum4 from "../../assets/images/museum4.jpg"
import museum5 from "../../assets/images/museum5.jpg"
import museum6 from "../../assets/images/museum6.jpg"
import museum7 from "../../assets/images/museum7.jpg"
import museum8 from "../../assets/images/museum8.jpg"
import LeftSection from "../../components/organisms/LeftSection";
import RightSection from "../../components/organisms/RightSection";
import {device} from "../../assets/styles/media";

const Desc = styled.div`
    color: #ed8e0c;
    margin-top: 15px;
    letter-spacing: -0.45px;
    font-size: 16px;

    ${device.tablet} {
        font-size: 17px;
    }
    
    ${device.mobile} {
      font-size: 15px;
    
    }
`;

const SubTitle = styled.p`
    color: #000;
    margin-bottom: 20px;
    font-size: 20px;
    font-weight: 500;
    ${device.mobile} {
        font-size: 15px;
        margin-bottom: 10px;
    }
`;
const TxT = styled.p`
    color: #4a4a4a;
    font-size: 18px;
    line-height: 1.56;
    letter-spacing: -0.45px;
    
    ${device.mobile} {
        font-size: 15px;
        line-height: 2;
    }
`;


const MuseumInfo = () => {
    const textList = [
        '테마파크의 대표 공간인 강아지숲 박물관에서는 “반려견과 인간의 아름다운 관계”에 대한 이야기들을 만나실 수 있습니다.\n\n전시에서는 반려견에 대한 이해를 돕는 다양한 전문적인 콘텐츠들을 전달하고 ' +
        '반려견과의 조화로운 삶을 위해 나아갈 방향을 모색합니다.\n\n사람과 개의 행복한 동행이 꿈이 아닌 현실이 되는 그 과정에 여러분의 이야기를 함께해보는 건 어떨까요?'
    ];
    const textList1 = [
        '반려견이 사람에게 특별한 존재가 될 수 밖에 없었던 이유는 무엇일까요?',
        '개와 사람의 흥미로운 역사와 그 관계를 들여다봅니다.',
    ];
    const textList2 = [
        '반려견의 입장에 서서 그들이 보고 있는 세상을 상상해 봅니다.전문가들로부터 반려견 양육 팁을 얻으며 반려견의 언어, 신체, 감정 등을 이해해 볼 수 있습니다.',
    ];
    const textList3 = [
        '사회는 함께 살아가는 공동체입니다. 우리 주변의 반려견 이슈와 서로 다른 입장들을 들춰보고, 반려견이 사회의 일원으로 함께 행복하기 위한 길을 모색합니다.',
    ];

    // 화면 렌더링
    return (
        <>
            <PageHeader
                bTitle="관람"
                detail="박물관"
                desc="강아지숲 박물관을 안내해 드립니다."
            />

            {/*section 1*/}
            <LeftSection
                title="강아지숲 박물관"
                enTitle="d.forest Museum"
                textList={textList}
                content={<Desc>강아지숲 박물관은 문화교육시설로서 방문객이 전시에 집중할 수 있게 강아지 출입을 제한하고 있습니다.</Desc>}
                img1={museum1}
                img2={museum2}
            />

            {/*section 2*/}
            <RightSection
                title="1 전시실"
                enTitle="d.forest Museum"
                content={<>
                    <SubTitle>서로 기대는 사이</SubTitle>
                    {textList1.map((el) => <TxT>{el}</TxT>)}
                </>}
                img1={museum3}
                img2={museum4}
            />

            {/*section 3*/}
            <LeftSection
                title="2 전시실"
                enTitle="d.forest Museum"
                content={<>
                    <SubTitle>서로 통하는 사이</SubTitle>
                    {textList2.map((el) => <TxT>{el}</TxT>)}
                </>}
                img1={museum5}
                img2={museum6}
            />

            {/*section 4*/}
            <RightSection
                title="3 전시실"
                enTitle="d.forest Museum"
                content={<>
                    <SubTitle>함께 걸어가는 사이</SubTitle>
                    {textList3.map((el) => <TxT>{el}</TxT>)}
                </>}
                img1={museum7}
                img2={museum8}
                simbol={false}
            />
        </>
    );
};

export default MuseumInfo;
